import { styled } from 'linaria/react';
import noiseTexture from 'assets/images/noise.png';
import { BREAKPOINTS, COLORS } from 'styles/constants';

export const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  margin: 0 auto;
  max-width: ${BREAKPOINTS.s}px;
  width: 100%;
  gap: 56px;
`;

export const StyledItem = styled.li<{ isBig?: boolean }>`
  display: block;
  padding: ${({ isBig }) => (isBig ? '0 12px 0' : '0 12px 0')};
  width: ${({ isBig }) => (isBig ? 100 : 50)}%;
  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    width: ${({ isBig }) => (isBig ? 100 : 49)}%;
    padding: ${({ isBig }) => (isBig ? '0 12px 0' : '0 12px 0')};
  }
`;

export const StyledWrap = styled.div<{ hideActionsInfo?: boolean; isDark?: boolean; gradientStartColor?: string }>`
  padding: 0 0 96px;
  position: relative;
  background: ${({ isDark }) => (isDark ? COLORS.black[100] : COLORS.white[100])};

  &.listGrid {
    background: ${({ isDark }) => (isDark ? COLORS.black[100] : COLORS.white[100])};
  }

  .action-user-info {
    display: ${({ hideActionsInfo }) => (hideActionsInfo ? 'none' : 'block')};
  }

  .hide-padding {
    padding-top: ${({ hideActionsInfo }) => (hideActionsInfo ? 0 : '12px')};
  }

  .action-comment-wrap {
  }
`;

export const StyledOverlay = styled.div<{ isDark: boolean; startColor: string; height: number; isMyProfile?: boolean }>`
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  width: 100vw;
  height: ${({ height }) => `${height - 40}px`};
  pointer-events: none;
  z-index: 0;
  background: url(${noiseTexture}),
    ${({ startColor, isDark, isMyProfile }) => {
      const topStop = isMyProfile === false ? '20%' : '5%';
      return `linear-gradient(180deg, ${startColor} ${topStop}, ${startColor} 65%, ${
        isDark ? COLORS.black[100] : COLORS.white[100]
      } 100%)`;
    }};
  -webkit-mask-image: ${({ isMyProfile }) =>
    `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
  mask-image: ${({ isMyProfile }) =>
    `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  pointer-events: none;
`;

export const StyledGrainWrap = styled.div<{ height: number; isMyProfile?: boolean }>`
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  width: 100vw;
  height: ${({ height }) => `${height}px`};
  pointer-events: none;
  z-index: 0; /* above gradient overlay, below content */
  mask-image: ${({ isMyProfile }) =>
    `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
  -webkit-mask-image: ${({ isMyProfile }) =>
    `linear-gradient(180deg, rgba(0, 0, 0, 1) ${isMyProfile === false ? '20%' : '5%'}, rgba(0, 0, 0, 0) 100%)`};
`;

export const StyledBtnWrap = styled.div`
  button {
    margin: 32px 24px 0 24px;
    width: -webkit-fill-available;

    div {
      margin: 0 auto;
    }
  }
`;
